import { path } from 'ramda';
// Info form normalizing
// Normalizing date fields, restricts user from picking startDate > endDate
const lessThanDate = (otherField: string) => (value: any, previousValue: any, allValues: any) => {
    if (path([otherField], allValues)) {
        return value < allValues[otherField] ? value : null;
    }
    else {
        return value;
    }
};
const greaterThanDate = (otherField: string) => (value: any, previousValue: any, allValues: any) => {
    if (path([otherField], allValues)) {
        return value > allValues[otherField] ? value : null;
    }
    else {
        return value;
    }
};
const onlyNums = (value: string): any => {
    return !value ? value : value.replace(/[^\d-]/g, '');
};
const onlyNumsAndDecimals = (value: string): any => !value ? value : value.replace(/[^\d.,]/g, '');
const charsSpaceNums = (value: string): any => !value ? value : value.replace(/[^[a-zA-ZäöüÄÖÜß0-9_ -]/g, '');
const charsSpace = (value: string): any => !value ? value : value.replace(/[^[a-zA-ZäöüÄÖÜß_ -]/g, '');
const noNums = (value: string): any => !value ? value : value.replace(/[^[a-zA-ZäöüÄÖÜß]/g, '');
const lessThan = (otherField: string) => (value: string, previousValue: string, allValues: any) => parseFloat(value) < parseFloat(allValues[otherField]) ? value : previousValue;
const greaterThan = (otherField: string) => (value: string, previousValue: string, allValues: any) => parseFloat(value) > parseFloat(allValues[otherField]) ? value : previousValue;
export { lessThanDate, greaterThanDate, onlyNums, charsSpace, charsSpaceNums, noNums, onlyNumsAndDecimals, lessThan, greaterThan };
